// @ts-nocheck
import React, { Component } from 'react';
import {
  Grid,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  Typography,
  withStyles,
  InfoOutlined as InfoOutlinedIcon,
} from '@quillbot/design-system';
import Img from '../img';

const useStyles = (theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
  },
  listItem: {
    background: theme.palette.background.default,
    borderRadius: '6px',
    padding: '5px 15px',
    marginBottom: '5px',
  },
  primaryText: {
    fontSize: '0.8em',
    fontWeight: 'bold',
  },
  greenText: {
    fontSize: '1.5em',
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  matIcon: {
    verticalAlign: 'middle',
  },
  sectionHeader: {
    fontWeight: 'bold',
  },
  goPremiumBtnHeader: {
    borderRadius: '15px !important',
  },
  premiumLink: {
    color: theme.palette.secondary.main,
    textTransform: 'uppercase',
    fontSize: '14px',
    fontWeight: 700,
    letterSpacing: '0.9px',
  },
});
class StatisticsDrawer extends Component {
  multiValueItem(itemLabel, from, to, tooltip) {
    const { classes } = this.props;
    return (
      <ListItem className={classes.listItem} alignItems="flex-start">
        <ListItemText
          classes={{
            primary: classes.primaryText,
          }}
          primary={
            <>
              <Grid container alignItems="center" spacing={1}>
                <Grid item md style={{ display: 'flex' }}>
                  {itemLabel}
                  {tooltip ? (
                    <Tooltip
                      placement="bottom-start"
                      title={tooltip}
                      classes={{ tooltip: classes.tooltip }}
                    >
                      <InfoOutlinedIcon
                        color="primary"
                        fontSize="small"
                        className={classes.matIcon}
                        style={{ marginLeft: '4px', paddingBottom: '5px' }}
                      />
                    </Tooltip>
                  ) : null}
                </Grid>
                <Grid container item md alignItems="center">
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                      component="span"
                      variant="body2"
                      className={classes.greenText}
                    >
                      {from}
                    </Typography>
                    <Typography component="span" variant="caption">
                      From
                    </Typography>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      padding: '3px',
                    }}
                  >
                    <Typography component="span" variant="caption">
                      {/* <TrendingFlatIcon color="action" /> */}
                      <Img src="/images/right-arrow-icon.svg" alt="arrow" />
                    </Typography>
                    <Typography component="span" variant="body2">
                      &nbsp;
                    </Typography>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                      component="span"
                      variant="body2"
                      className={classes.greenText}
                    >
                      {to}
                    </Typography>
                    <Typography component="span" variant="caption">
                      To
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </>
          }
        />
      </ListItem>
    );
  }

  singleValueItem(itemLabel, itemValue, tooltip) {
    const { classes } = this.props;
    return (
      <ListItem className={classes.listItem} alignItems="flex-start">
        <ListItemText
          classes={{
            primary: classes.primaryText,
          }}
          primary={
            <Grid container spacing={1} alignItems="center">
              <Grid item md>
                {itemLabel}
                {tooltip ? (
                  <Tooltip
                    placement="bottom-start"
                    title={tooltip}
                    classes={{ tooltip: classes.tooltip }}
                  >
                    <InfoOutlinedIcon
                      color="primary"
                      fontSize="small"
                      className={classes.matIcon}
                      style={{ marginLeft: '4px', paddingBottom: '5px' }}
                    />
                  </Tooltip>
                ) : null}
              </Grid>
              <Grid item md>
                <Typography
                  component="span"
                  variant="body2"
                  className={classes.greenText}
                >
                  {itemValue}
                </Typography>
              </Grid>
            </Grid>
          }
        />
      </ListItem>
    );
  }

  render() {
    const { classes, stats, showStats, defaultText } = this.props;
    return (
      <div style={{ display: 'relative' }}>
        {stats && stats.length > 0 && showStats ? (
          <List
            className={classes.root}
            disablePadding
            style={{ marginTop: '15px' }}
          >
            {stats.map((item) => {
              if (item.type === 'singleValue') {
                return this.singleValueItem(
                  item.name,
                  item.value,
                  item.tooltipText
                );
              }
              return this.multiValueItem(
                item.name,
                item.value.from,
                item.value.to,
                item.tooltipText
              );
            })}
          </List>
        ) : (
          <Typography variant="body1" style={{ marginTop: '15px' }}>
            {defaultText}
          </Typography>
        )}
      </div>
    );
  }
}

export default withStyles(useStyles)(StatisticsDrawer);
